import ProjectCalculationList from './ProjectCalculationList'
import ProjectCalculationForm from './ProjectCalculationForm'

export default {
    ProjectCalculationList,
    ProjectCalculationForm,
}
